import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { TwitterTweetButtonInterface } from 'common/types/entities/TwitterTweetButtonInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export const createTwitterTweetButton = (
  parentId: string,
  masterBlockId?: MasterBlockId,
): TwitterTweetButtonInterface => {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.TwitterTweetButton,
      parentId,
      masterBlockId,
    ),
    type: EntityTypeEnum.TwitterTweetButton,
    text: '',
    alignSelf: 'center',
  }
}
